window.addEventListener('DOMContentLoaded', function() {
  $(".pillar-tabs li a").on("click", function (e) {
    e.preventDefault();

    var targetTab = $(this).attr("data-target-tab");
    $(".pillar-tabs li a").removeClass("active");
    $(this).addClass("active");

    var header_h = ($(".pillar-tabs").height())+160;
    var tab_h = $("#" + targetTab).offset().top;
    var scroll_h = tab_h - header_h;

    if ($(window).width() < 768) {
      scroll_h = tab_h;
    }

    if($(this).hasClass('active')){
      $("html,body").animate({
        scrollTop: (scroll_h)
      }, "fast");
    }
  });

  function sticky() {
    var header = $(".pillar-tabs");
    var sticky = header.offset();
    if ($(window).width() > 768) {
      moveSticky();
      function moveSticky() {
        window.onscroll = function () {
          if (sticky != undefined) {
            if (window.pageYOffset > sticky.top) {
              header.addClass("tabs-sticky");
            } else {
              header.removeClass("tabs-sticky");
            }
          }
        };
      }
    }else{
      window.onscroll = function () {
        header.removeClass("tabs-sticky");
        return false;
      };
    }
  };
  sticky();
  $(window).resize(sticky);

});